const Loading = () => {
  return (
    <div className="h-screen overflow-hidden z-[10] flex items-center justify-center">
      <h2 className="font-extrabold text-[36px]">Loading...</h2>
    </div>
  );
};

export default Loading;
